import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/settingactive/bandwidth.svg")